import { render, staticRenderFns } from "./Form2_Persona2.vue?vue&type=template&id=d3ae237e"
import script from "./Form2_Persona2.vue?vue&type=script&lang=js"
export * from "./Form2_Persona2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dayanamartinez/Developer/laas_simulator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d3ae237e')) {
      api.createRecord('d3ae237e', component.options)
    } else {
      api.reload('d3ae237e', component.options)
    }
    module.hot.accept("./Form2_Persona2.vue?vue&type=template&id=d3ae237e", function () {
      api.rerender('d3ae237e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios2/BNF/Form2_Persona2.vue"
export default component.exports